import { Platform } from 'react-native';
let lockCount = 0;
const isWeb = Platform.OS === 'web';
export const useLockScroll = (isLock = true) => {
    const lock = () => {
        if (isWeb) {
            lockCount++;
            const locked = document.body.style.overflow;
            if (locked !== 'hidden' && lockCount) {
                document.body.style.overflow = 'hidden';
            }
        }
    };
    const unlock = () => {
        if (isWeb) {
            lockCount--;
            const locked = document.body.style.overflow;
            if (locked === 'hidden' && !lockCount) {
                document.body.style.overflow = 'auto';
            }
        }
    };
    return {
        lock,
        unlock
    };
};
